import { IChecklistTask } from '@features/Checklist/model/types';

export const serializeChecklistToMarkdown = (items: IChecklistTask[]): string =>
    items
        .map((item) => item.text.trim())
        .filter(Boolean)
        .map((text) => `- [ ] ${text}`)
        .join('\n');
